import React from 'react';
import './Nav.css';

// FIXME: can be optimized with React.memo
const Nav = ({ children }: { children: React.ReactNode }) => (
  <ul className="nav">{children}</ul>
);

export default Nav;
